module.exports = __webpack_public_path__ + "static/media/HK-HKMU.c5231bfc.png";